import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_branch_pricing_scheme_hdr_link_RowClass} from '../../dbschema/bl_fi_mst_branch_pricing_scheme_hdr_link.model';

export class BranchPricingSchemeHdrLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_branch_pricing_scheme_hdr_link: bl_fi_mst_branch_pricing_scheme_hdr_link_RowClass = new bl_fi_mst_branch_pricing_scheme_hdr_link_RowClass();
}
